
/* styles */
require("!!../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-31518f94&scoped=true!sass-loader?sourceMap!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./notification.vue")

var Component = require("!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./notification.js"),
  /* template */
  require("!!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-31518f94!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./notification.vue"),
  /* scopeId */
  "data-v-31518f94",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/account/notification.vue
// module id = 1917
// module chunks = 1